<div class="filter-base-container">
  <div class="filter-header" *ngIf="![9, 10, 11].includes(column.filterType!)">
    <span *ngIf="withLabels">{{ column.label }}</span>
    <nz-select
      *ngIf="column != null"
      [ngModel]="selectedFilterOprCode"
      (ngModelChange)="selectFilterOperator($event)"
      nzBorderless
      class="filter-operator-drp">
      <nz-option
        [nzValue]="op.code"
        [nzLabel]="op.label"
        *ngFor="let op of fieldFilterOprs"
      ></nz-option>
    </nz-select>
  </div>
  <div
    class="filter-input-container"
    *ngIf="
      selectedFilterOpr != null && ![4, 5].includes(selectedFilterOpr.operator)
    "
  >
    <ng-container [ngSwitch]="column.filterType">
      <div
        *ngSwitchCase="FilterTypes.String"
        class="filter-input-field filter-input-string"
      >
        <app-text-filter
          [fieldFilterOprs]="fieldFilterOprs"
          [col]="column"
          [value]="value"
          (onModelChange)="onFilterValueChange($event)"
        ></app-text-filter>
      </div>
      <div
        *ngSwitchCase="FilterTypes.Text"
        class="filter-input-field filter-input-string"
      >
        <app-text-filter
          [col]="column"
          [value]="value"
          (onModelChange)="onFilterValueChange($event)"
        ></app-text-filter>
      </div>
      <div
        *ngSwitchCase="FilterTypes.Html"
        class="filter-input-field filter-input-string"
      >
        <app-text-filter
          [col]="column"
          [value]="value"
          (onModelChange)="onFilterValueChange($event)"
        ></app-text-filter>
      </div>
      <div
        *ngSwitchCase="FilterTypes.Number"
        class="filter-input-field filter-input-string"
      >
        <app-number-filter
          [operator]="selectedFilterOpr"
          [col]="column"
          [value]="value"
          (onModelChange)="onFilterValueChange($event)"
        ></app-number-filter>
      </div>
      <div
        *ngSwitchCase="FilterTypes.Date"
        class="filter-input-field filter-input-date"
      >
        <app-date-filter
          [operator]="selectedFilterOpr"
          [col]="column"
          [value]="value"
          (onModelChange)="onFilterValueChange($event)"
        ></app-date-filter>
      </div>
      <div
        *ngSwitchCase="FilterTypes.Select"
        class="filter-input-field filter-input-select"
      >
        <app-select-filter
          [operator]="selectedFilterOpr"
          [col]="column"
          [value]="value"
          (onModelChange)="onFilterValueChange($event)"
        ></app-select-filter>
      </div>
      <div
        *ngSwitchCase="FilterTypes.MultiSelect"
        class="filter-input-field filter-input-select"
      >
        <app-select-filter
          [operator]="selectedFilterOpr"
          [col]="column"
          [value]="value"
          (onModelChange)="onFilterValueChange(column)"
        ></app-select-filter>
      </div>
      <div
        *ngSwitchCase="FilterTypes.Boolean"
        class="filter-input-field filter-input-select"
      >
        <app-boolean-filter
          [col]="column"
          [value]="value"
          (onModelChange)="onFilterValueChange($event)"
        ></app-boolean-filter>
      </div>
      <div *ngSwitchDefault></div>
    </ng-container>
  </div>
</div>